export default {
  id: '',
  isIncognito: false,
  isReady: false,
};
